/**
 * Fix: on a horizontally-scrollable slider ([id^="Slider-"], used by every
 * slideshow-component / slider-component carousel in the Primavera theme),
 * Chrome/Safari remap a vertical mouse-wheel gesture into horizontal
 * scrollLeft movement. That silently "eats" the wheel event and blocks the
 * whole page from scrolling while the cursor happens to be over a full-bleed
 * slider — most importantly the homepage hero, which spans the entire first
 * viewport, so visitors landing on the site could not scroll down with a
 * mouse wheel.
 *
 * When the gesture is vertically dominant (a normal mouse wheel, not a
 * horizontal trackpad swipe), forward it to the page instead of letting the
 * browser consume it horizontally. Horizontal/trackpad gestures are left
 * untouched so existing carousel swipe-to-scroll behavior still works.
 *
 * Delegated on document so it also covers sliders added to the DOM after
 * initial load (e.g. inside modals or infinite-scroll collections).
 */
document.addEventListener(
  'wheel',
  function (event) {
    var slider = event.target.closest && event.target.closest('[id^="Slider-"]');
    if (!slider) return;
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      event.preventDefault();
      window.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
    }
  },
  { passive: false }
);
